import addRef from './addRef'
import cloneElement from './cloneElement'
import Component from './Component'
import h from './h'
import render from './render'

export {
  addRef as ref,
  addRef,
  cloneElement,
  Component,
  h,
  render
}
